import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["query", "category", "section", "item", "count", "empty"]

  connect() {
    this.filter()
  }

  filter() {
    const query = this.queryTarget.value.trim().toLowerCase()
    const category = this.categoryTarget.value
    let visible = 0

    this.itemTargets.forEach((item) => {
      const matchesQuery = !query || item.dataset.templateSearch.includes(query)
      const matchesCategory = !category || item.dataset.templateCategory === category
      item.hidden = !(matchesQuery && matchesCategory)
      if (!item.hidden) visible += 1
    })

    this.sectionTargets.forEach((section) => {
      section.hidden = !Array.from(section.querySelectorAll("[data-template-filter-target='item']"))
        .some((item) => !item.hidden)
    })

    this.countTarget.textContent = `${visible} template${visible === 1 ? "" : "s"}`
    this.emptyTarget.hidden = visible > 0
  }
}
